import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const StyledRoot = styled.div(({ theme: { colors }, brandColorBg, brandColorText }) => ({
  backgroundColor: brandColorBg || colors.white,
  color: brandColorText || colors.dark_grey,
  position: 'relative',
  paddingBottom: 'min(20%, 150px)', // for bigger devices: max 150px height
  minHeight: '80px', // for smaller devices: min 80px height
}))

const StyledHeaderWrapper = styled.div(({ theme: { spaces } }) => ({
  position: 'absolute',
  top: 0,
  left: spaces.default / 2,
  right: spaces.default / 2,
  bottom: 0,
}))

const StyledHeader = styled.div(() => ({
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

const StyledTitle = styled.h3(({ theme: { breakpoints, fonts, categoryBannerFontSizes } }) => ({
  fontFamily: fonts.montserrat,
  fontSize: categoryBannerFontSizes.mobile,
  lineHeight: `${categoryBannerFontSizes.mobile * 1.2}px`,
  textAlign: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  wordBreak: 'break-word',
  [`@media (min-width: ${breakpoints.medium})`]: {
    fontSize: categoryBannerFontSizes.tablet,
    lineHeight: `${categoryBannerFontSizes.tablet * 1.2}px`,
  },
  [`@media (min-width: ${breakpoints.large})`]: {
    fontSize: categoryBannerFontSizes.desktop,
    lineHeight: `${categoryBannerFontSizes.desktop * 1.2}px`,
  },
}))

const ProductsHeader = ({
  category, brandColorBg, brandColorText,
}) => (
  <StyledRoot data-test="ProductsHeader" brandColorBg={brandColorBg} brandColorText={brandColorText}>
    <StyledHeaderWrapper>
      <StyledHeader>
        <StyledTitle>{category}</StyledTitle>
      </StyledHeader>
    </StyledHeaderWrapper>
  </StyledRoot>
)

ProductsHeader.propTypes = {
  category: PropTypes.string,
  brandColorBg: PropTypes.string,
  brandColorText: PropTypes.string,
}

ProductsHeader.defaultProps = {
  category: '',
  brandColorBg: '',
  brandColorText: '',
}

export default ProductsHeader
